import {VariantConfigT} from '@/lib/types/colors.types';

export const primaryConfig: VariantConfigT = {
  basic: {
    icon: 'primary',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'primary',
    active: 'primary',
  },
  outline: {
    icon: 'primary',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'primary',
    iconHover: 'primary',
    iconActive: 'primary',
    hover: 'primary',
    active: 'primary',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
